/* ALIZÉ — Reveal animation on scroll (Intersection Observer)
   Respecte prefers-reduced-motion. Aucune dépendance.
   Safety belt: in Shopify theme editor (design mode), reveal everything
   immediately so sections never stay invisible while the merchant edits. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  const revealAll = () => {
    document.querySelectorAll('.alz-reveal').forEach(el => el.classList.add('is-visible'));
  };

  // Reduced motion: skip animation entirely.
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    revealAll();
    document.addEventListener('shopify:section:load', revealAll);
    return;
  }

  // Theme editor: don't gate on scroll — merchants need to see sections immediately.
  if (window.Shopify && window.Shopify.designMode) {
    revealAll();
    document.addEventListener('shopify:section:load', revealAll);
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  const init = () => {
    document.querySelectorAll('.alz-reveal:not(.is-visible)').forEach(el => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
